/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable jsx-a11y/control-has-associated-label */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useVideoState } from '../../contexts/SiteContext';
import Embed from '../blocks/Embed';
import FilmButtons from './FilmButtons';
import FilmDescription from './FilmDescription';
import FilmTitle from './FilmTitle';
import Image from './Image';

import styles from '../../../styles/partials/film-trailer.module.scss';

const propTypes = {
    item: AppPropTypes.page.isRequired,
    onClose: PropTypes.func.isRequired,
    trailerOnly: PropTypes.bool,
    imageOnly: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    trailerOnly: false,
    imageOnly: false,
    className: null,
};

const FilmTrailer = ({ item, className, onClose, trailerOnly, imageOnly }) => {
    const { muted = true, setMuted = null } = useVideoState();

    const { image = null, poster = null, trailer = null } = item;
    const { url: imageUrl = null } = image || {};
    const { url: trailerUrl = null, provider } = trailer || {};
    const validTrailer =
        trailerUrl !== null &&
        (provider === 'youtube' || provider === 'vimeo' || provider === 'embed');
    const { colors = null } = poster || image || {};
    const [fromColor = null, toColor = null] = colors || [];
    const displayFallback = imageOnly || !validTrailer;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.hasTrailer]: !trailerOnly && trailerUrl !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {trailerUrl === null && imageUrl === null ? (
                    <div className={styles.visualFallback} />
                ) : null}
                {imageUrl !== null ? (
                    <div
                        className={styles.trailerContainer}
                        style={
                            fromColor !== null && toColor !== null
                                ? {
                                      backgroundImage: `linear-gradient(135deg, ${fromColor} 0%, ${toColor} 100%)`,
                                  }
                                : null
                        }
                    >
                        <Image
                            className={classNames([
                                styles.trailerFallback,
                                { [styles.isVisible]: displayFallback },
                            ])}
                            imageClassName={styles.trailerFallbackImg}
                            fit
                            cover
                            media={image || poster}
                        />
                        {validTrailer && !imageOnly ? (
                            <Embed
                                embed={trailer}
                                autoPlay
                                initialMuted={muted}
                                onMutedChanged={setMuted}
                                className={styles.trailer}
                                videoClassName={styles.video}
                            />
                        ) : null}
                    </div>
                ) : null}
                {!trailerOnly ? (
                    <div className={styles.content}>
                        <div className={styles.innerContent}>
                            <div className={styles.generalInfo}>
                                <FilmTitle
                                    linkClassName={styles.link}
                                    titleClassName={styles.title}
                                    item={item}
                                    onClick={onClose}
                                    isLink
                                />
                            </div>
                            <FilmButtons item={item} className={styles.actions} onClose={onClose} />
                        </div>
                        <FilmDescription item={item} className={styles.description} isDark />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

FilmTrailer.propTypes = propTypes;
FilmTrailer.defaultProps = defaultProps;

export default FilmTrailer;
